var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { BigNumber } from "@ethersproject/bignumber";
import { useWeb3React } from "@web3-react/core";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { RibbonTokenAddress } from "../constants/constants";
import { impersonateAddress } from "../utils/development";
import { getSubgraphqlURI } from "../utils/env";
var useRBNTokenAccount = function () {
    var web3Context = useWeb3React();
    var account = impersonateAddress ? impersonateAddress : web3Context.account;
    // TODO: Global state
    var _a = useState(), data = _a[0], setData = _a[1];
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var loadData = useCallback(function (acc) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setLoading(true);
                    _a = setData;
                    return [4 /*yield*/, fetchTokenSubgraph(acc)];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    setLoading(false);
                    return [2 /*return*/];
            }
        });
    }); }, []);
    useEffect(function () {
        if (account) {
            loadData(account);
        }
    }, [account, loadData]);
    return { data: data, loading: loading };
};
var fetchTokenSubgraph = function (account) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, axios.post(getSubgraphqlURI(), {
                    query: "\n        {\n          erc20TokenAccount(id:\"" + RibbonTokenAddress.toLowerCase() + "-" + account.toLocaleLowerCase() + "\") {\n            token {\n              name\n              symbol\n              numHolders\n              holders\n              tokenAccounts\n              totalSupply\n            }\n            balance\n            account\n          }\n        }\n        ",
                })];
            case 1:
                response = _a.sent();
                return [2 /*return*/, response.data.data.erc20TokenAccount
                        ? __assign(__assign({}, response.data.data.erc20TokenAccount), { balance: BigNumber.from(response.data.data.erc20TokenAccount.balance), token: __assign(__assign({}, response.data.data.erc20TokenAccount.token), { totalSupply: BigNumber.from(response.data.data.erc20TokenAccount.token.totalSupply) }) }) : undefined];
        }
    });
}); };
export default useRBNTokenAccount;
//# sourceMappingURL=useRBNTokenAccount.js.map